/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAccountingLocationParams,
  GetAccountingLocationResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get Onboarding Accounting Locations by ID
 */
export const getAccountingLocation = (
  id: string,
  params?: GetAccountingLocationParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetAccountingLocationResponseResponse>({
    url: `/bm-accounting-location/v1/${id}`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetAccountingLocationQueryKey = (
  id: string,
  params?: GetAccountingLocationParams,
) => {
  return [`/bm-accounting-location/v1/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetAccountingLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountingLocation>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  id: string,
  params?: GetAccountingLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountingLocation>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountingLocationQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountingLocation>>> = ({ signal }) =>
    getAccountingLocation(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountingLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountingLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountingLocation>>
>;
export type GetAccountingLocationQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get Onboarding Accounting Locations by ID
 */
export const useGetAccountingLocation = <
  TData = Awaited<ReturnType<typeof getAccountingLocation>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  id: string,
  params?: GetAccountingLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountingLocation>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAccountingLocationQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
